import './TextBlock.scss'

import {LinkType, WysiwygType} from '../../types'
import React, {useEffect} from 'react'

import {Block} from './Blocks'
import {Theme} from '../../views/Theme'
import {style} from '../../util/style'

const styles = style('textblock')

export type TextBlockType = {
	bgcolor?: boolean
	text: WysiwygType
	button?: LinkType
	text_tooltips?: Array<TextBlockTooltipType>
}

type TextBlockTooltipType = {
	tooltip_key: string
	tooltip_text: WysiwygType
}

export const TextBlock: React.FC<
	TextBlockType & {container?: boolean; sidebar?: boolean}
> = ({container, sidebar, bgcolor, text, button, text_tooltips}) => {
	if (!text && !button) return null

	const addTooltips = (input: WysiwygType) => {
		if (!input) return null
		return input.replace(/{{(.+?)::(.+?)}}/g, (match, key, value) => {
			const found = text_tooltips.find((t) => t.tooltip_key === key)
			let tipText = !found ? '' : found.tooltip_text
			tipText = tipText
				.replace('<strong>', '<b>')
				.replace('</strong>', '</b>')
				.replace(/\n/g, '::NEWLINE::')
			tipText = tipText.replace(/<[^\/abi\s]+?[^>]*>|<\/[^abi]>/g, '')
			tipText = tipText.replace('::NEWLINE::', '<br/>')
			const tip = `<span class="${styles('tooltip-data')}">${tipText}</span>`
			return `<span class="${styles('tooltip')}">${value}${tip}</span>`
		})
	}

	const tooltipText = addTooltips(text)

	return (
		<Block className={styles()} container={container} sidebar={sidebar}>
			<div className={styles('content')}>
				<div className={styles('content-text')}>
					<Theme.Wysiwyg>{tooltipText}</Theme.Wysiwyg>
				</div>
				{button?.url && (
					<div className={styles('content-button')}>
						<Theme.Button to={button.url}>
							{button.description || button.title}
						</Theme.Button>
					</div>
				)}
			</div>
		</Block>
	)
}
